import { VoziqOfferFlow } from './voziqOfferFlow.service';
import { VoziqOffer, VoziqOfferContext, VoziqSaving } from './types';

const ShopCartHref = '/shop/cart';

class VoziqAcceptedModalController {
    public resolve: {
        offer: VoziqOffer;
        saving: VoziqSaving | null;
        applied: boolean;
        context: VoziqOfferContext;
    };
    public close: () => void;

    constructor(private $window: Window, private voziqOfferFlow: VoziqOfferFlow) {
        'ngInject';
    }

    public get savingMissing() {
        return this.resolve.offer.Kind !== 'Rmr' && !this.resolve.saving;
    }

    public get inShop() {
        return this.resolve.context === 'shop';
    }

    public goToCart() {
        if (!this.inShop && this.resolve.saving) {
            this.voziqOfferFlow.keepPendingSaving(this.resolve.offer, this.resolve.saving);
        }
        this.$window.location.href = ShopCartHref;
    }
}

export const voziqAcceptedModal = {
    template: require('./voziqAcceptedModal.html'),
    bindings: {
        resolve: '<',
        close: '&'
    },
    controller: VoziqAcceptedModalController
};
